import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ExpandRightLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "m9 6 6 6-6 6" })));
}
const ExpandRightLight = forwardRef(_ExpandRightLight);
export { ExpandRightLight };
